module.exports = __webpack_public_path__ + "static/media/hg3.a8d5eab1.jpeg";